import classNames from 'classnames';
import React, { HTMLAttributes } from 'react';
import { Button } from 'components/atoms'
import './index.scss';
import { FileExcelOutlined, FormOutlined, ShrinkOutlined, ArrowsAltOutlined } from '@ant-design/icons';

interface TotalNumMenuProps {
  totalNum?: number;
  text?: string;
  title?: string;
  useRegister?: boolean;
  useExcelDownload?: boolean;
  onUseRegister?: () => void;
  onDownloadExcel?: () => void;
  onExpaned?: (val:boolean) => void;
}

const cx = classNames.bind('./index.scss');

const TotalNumMenu = ({ 
  totalNum, 
  text, 
  title='',
  useRegister = false,
  useExcelDownload = false, 
  onUseRegister,
  onDownloadExcel,  
  onExpaned, 
  ...props }: TotalNumMenuProps): React.ReactElement => {
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={cx('totalHeader')} {...props} style={{marginBottom:5}}>
      <div>
        {title}{text || `총 ${totalNum ?? 0} 개의 항목이 있습니다.`}
      </div>
      <div>
        { (onExpaned) && (<><Button size='small' onClick={()=>onExpaned(true)}>전체열기</Button><Button size='small' onClick={()=>onExpaned(false)}>전체닫기</Button></>)}
        { (useRegister) && (<Button size='small' icon={<FormOutlined />} onClick={onUseRegister}>등록</Button>)}
        { (useExcelDownload) && (<Button size='small' icon={<FileExcelOutlined />} onClick={onDownloadExcel}>엑셀다운로드</Button>)}
      </div>
    </div>    
  );
};

export default React.memo(TotalNumMenu);
